var IMAGE_ASPECT_RATIO, TABLET_MQ_WIDTH, ZOOM_HOVER_DELAY;

TABLET_MQ_WIDTH = 768;

IMAGE_ASPECT_RATIO = 0.6;

ZOOM_HOVER_DELAY = 200;

if (window.DealCarousel == null) {
  window.DealCarousel = {};
}

DealCarousel.View = Backbone.View.extend({
  events: {
    'click .gallery-control-back': 'onBackClick',
    'click .gallery-control-forward': 'onForwardClick',
    'click .gallery-control-left': 'onLeftClick',
    'click .gallery-control-right': 'onRightClick',
    'click .gallery-thumbnail': 'onThumbnailClick',
    'mouseenter .zoom-controls': 'onZoomIn',
    'mouseenter .zoom-controls .gallery-control-left': 'onZoomOut',
    'mouseenter .zoom-controls .gallery-control-right': 'onZoomOut',
    'mouseleave .zoom-controls': 'onZoomOut',
    'mouseleave .zoom-controls .gallery-control-left': 'onZoomIn',
    'mouseleave .zoom-controls .gallery-control-right': 'onZoomIn',
    'mousemove .zoom-controls': 'onZoomMove'
  },
  initialize: function() {
    var base;
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.currentFeatured = this.options.featured || this.collection.first();
    this.$featuredContainer = $('.featured-image-container');
    this.collection.classes = '';
    this.collection.view = this;
    this.collection.videoBHD = JSON.stringify({
      video: true
    });
    this.collection.featured = (function(_this) {
      return function() {
        return _this.currentFeatured;
      };
    })(this);
    this.collection.uuid = this.options.uuid;
    this.collection.renderFullCarousel = this.collection.length > 1;
    this.collection.showThumbs = this.options.showThumbs;
    this.collection.imageZoom = this.options.imageZoom;
    this.collection.lazyLoadThumbs = this.options.lazyLoadThumbs && !this.options.lazyLoadFeaturedImage;
    this.collection.shouldShowImageBadge = this.options.shouldShowImageBadge;
    this.collection.lazyLoadFeaturedImage = this.options.lazyLoadFeaturedImage;
    this.collection.badge = this.options.badge;
    return (base = this.options).imageQualty != null ? base.imageQualty : base.imageQualty = '';
  },
  render: function() {
    var el, featuredIndex, renderOptions;
    this.$el = $(this.el);
    this.$body = $(document.body);
    this.rtl = this.$body.hasClass('rtl');
    renderOptions = _.extend({
      showRTL: this.rtl
    }, this.collection);
    if (this.collection.lazyLoadFeaturedImage && this.$featuredContainer.hasClass('preload')) {
      renderOptions.preload = true;
    }
    el = DealCarousel.CarouselTemplate.render(renderOptions);
    this.$el = $(el).replaceAll(this.$el);
    this.el = this.$el[0];
    this.$thumbs = this.$el.find(".gallery-thumbs");
    this.$thumbnails = this.$thumbs.children();
    this.$gallery = this.$el.find(".gallery-featured");
    this.$galleryMedia = this.$gallery.find("img");
    this.$zoomMedia = this.$gallery.find(".zoom-in-image");
    this.$clickBlocker = this.$el.find(".click-blocker");
    this.$imageZoomMessage = this.$el.find(".image-zoom-message");
    this.$controls = this.$el.find(".gallery-controls");
    this.$backButton = this.$controls.find(".gallery-control-back");
    this.$forwardButton = this.$controls.find(".gallery-control-forward");
    this.$leftButton = this.$controls.find(".gallery-control-left");
    this.$rightButton = this.$controls.find(".gallery-control-right");
    this.containerWidth = this.$el.width();
    this.insideContainerWidth = this.containerWidth - this.$backButton.width() - this.$forwardButton.width();
    this.animateViaJS = !this.$body.parent('html').hasClass('cssanimations');
    this.thumbsWidth = this.$thumbs.width();
    this.thumbWidth = this.$thumbs.children().outerWidth();
    if (this.rtl) {
      this.thumbMargin = parseInt(this.$thumbs.children().css("margin-left"));
    } else {
      this.thumbMargin = parseInt(this.$thumbs.children().css("margin-right"));
    }
    this.thumbsWidth = this._calculateThumbsWidth();
    this.media = {};
    this.currentPosition = 0;
    this.hasOverflow = this.thumbsWidth > this.containerWidth;
    this.setFeaturedHeight();
    this.centerThumbs();
    featuredIndex = this.collection.indexOf(this.currentFeatured);
    this.fetchInitialMedia(featuredIndex);
    this._prepareGroups();
    this._prepareImageZoom();
    if (featuredIndex !== 0) {
      this._adjustThumbs(featuredIndex);
    }
    return this.delegateEvents();
  },
  centerThumbs: function() {
    var direction;
    this.thumbsWidth = this._calculateThumbsWidth();
    this.$thumbs.width(this.thumbsWidth);
    if (!this.hasOverflow) {
      return this.visibleThumbs = this.$thumbnails.length;
    } else {
      direction = this.rtl ? 'right' : 'left';
      this.visibleThumbs = Math.floor(this.insideContainerWidth / this.thumbWidth);
      this.visibleThumbs--;
      this.$el.addClass("has-navigation");
      return this.$thumbs.css(direction, this.$backButton.width() + this.thumbMargin);
    }
  },
  fetchMedia: function(index) {
    var media;
    media = this.collection.at(index);
    if (this.media[media.id] != null) {
      return false;
    }
    if (media.type === "video") {
      return this.fetchVideo(media);
    } else {
      this.fetchImage(media);
      return this.fetchZoomImage(media);
    }
  },
  fetchImage: function(image) {
    var $newImage, newImage;
    newImage = new Image();
    newImage.src = image.media;
    $newImage = $(newImage);
    $newImage.data("id", image.id);
    $newImage.attr("id", "gallery-image-" + image.id);
    if (image.alt != null) {
      $newImage.attr("alt", image.alt);
    } else {
      $newImage.attr("alt", "");
    }
    return this.media[image.id] = $newImage;
  },
  fetchZoomImage: function(image) {
    var zoomImage;
    if (!image.zoom) {
      return;
    }
    zoomImage = new Image();
    return zoomImage.src = image.zoom;
  },
  fetchVideo: function(video) {
    var playerId;
    playerId = video.provider === "KALTURA" ? "kaltura-player-1360194818" : video.provider === "OOYALA" ? "ooyala-player" : video.provider === "YOUTUBE" ? "yt-player" : void 0;
    return this.media[video.id] = $("<div/>", {
      id: "video-container"
    }).attr("data-bhw", "PromNightVideo").html("<div id=\"" + playerId + "\" style=\"width:" + this.containerWidth + "px; height:" + this.options.mediaHeight + "px; margin: 0 auto;\"></div>");
  },
  fetchInitialMedia: function(start) {
    var collectionSize, i, j, loadCount, ref, ref1, results;
    if (start == null) {
      start = 0;
    }
    loadCount = 1;
    if (this.options.prefetchImages) {
      collectionSize = this.collection.size();
      loadCount = this.visibleThumbs;
      if (start + loadCount > collectionSize) {
        loadCount = collectionSize - start;
      }
    }
    results = [];
    for (i = j = ref = start, ref1 = start + loadCount; ref <= ref1 ? j < ref1 : j > ref1; i = ref <= ref1 ? ++j : --j) {
      results.push(this.fetchMedia(i));
    }
    return results;
  },
  onBackClick: function(e, skipRtlCheck) {
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!this.hasOverflow) {
      return;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onForwardClick(null, true);
      }
    }
    if (this.activeGroup > 0) {
      this.activeGroup--;
    } else {
      this.activeGroup = this.totalGroups - 1;
    }
    return this._updateThumbsPosition();
  },
  onForwardClick: function(e, skipRtlCheck) {
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!this.hasOverflow) {
      return;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onBackClick(null, true);
      }
    }
    if (this.activeGroup < this.totalGroups - 1) {
      this.activeGroup++;
    } else {
      this.activeGroup = 0;
    }
    return this._updateThumbsPosition();
  },
  onLeftClick: function(e, skipRtlCheck) {
    var currentThumb, newMedia;
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onRightClick(null, true);
      }
    }
    currentThumb = this.collection.indexOf(this.currentFeatured);
    if (currentThumb > 0) {
      newMedia = this.collection.at(currentThumb - 1);
      this.updateGallery(newMedia);
    } else {
      newMedia = this.collection.at(this.collection.size() - 1);
      this.updateGallery(newMedia);
    }
    return this._setActiveGroup();
  },
  onRightClick: function(e, skipRtlCheck) {
    var currentThumb, newMedia;
    if (skipRtlCheck == null) {
      skipRtlCheck = false;
    }
    if (!skipRtlCheck) {
      if (this.rtl) {
        return this.onLeftClick(null, true);
      }
    }
    currentThumb = this.collection.indexOf(this.currentFeatured);
    if (currentThumb < this.collection.size() - 1) {
      newMedia = this.collection.at(currentThumb + 1);
      this.updateGallery(newMedia);
    } else {
      newMedia = this.collection.at(0);
      this.updateGallery(newMedia);
    }
    return this._setActiveGroup();
  },
  onZoomIn: function(e) {
    if (this.$backButton.is(e.target) || this.$forwardButton.is(e.target)) {
      return;
    }
    if (!this.currentFeatured.zoom) {
      return;
    }
    this.$zoomMedia.css("background-image", "url('" + this.currentFeatured.zoom + "')");
    return this.$el.addClass("image-zoom");
  },
  onZoomOut: function(e) {
    if (this.$backButton.is(e.target) || this.$forwardButton.is(e.target)) {
      return;
    }
    return this.$el.removeClass("image-zoom");
  },
  onZoomMove: function(e) {
    var left, offset, top;
    if (!(this.$controls.is(e.target) && this.currentFeatured.zoom)) {
      return;
    }
    offset = this.$gallery.offset();
    left = this.zoomFactor * (offset.left - e.pageX);
    top = this.zoomFactor * (offset.top - e.pageY);
    return _.throttle(this.$zoomMedia.css("background-position", left + "px " + top + "px"), ZOOM_HOVER_DELAY);
  },
  onThumbnailClick: function(e) {
    var $thumb, newMedia;
    $thumb = this.$thumbs.find(e.currentTarget);
    newMedia = this.collection.get($thumb.data("id"));
    if (newMedia === this.currentFeatured) {
      return;
    }
    return this.updateGallery(newMedia);
  },
  playVideo: function(media) {
    if (media.provider === "KALTURA") {
      return kWidget.embed({
        "targetId": "kaltura-player-1360194818",
        "cache_st": 1360194818,
        "wid": "_1302621",
        "uiconf_id": "11486911",
        "flashvars": {
          "autoPlay": true,
          "streamerType": "hdnetwork",
          "akamaiHD": {
            "loadingPolicy": "preInitialize",
            "asyncInit": "true"
          }
        },
        "entry_id": media.media
      });
    } else if (media.provider === "OOYALA") {
      return this.videoPlayer = OO.Player.create('ooyala-player', media.media, {
        autoplay: true
      });
    } else if (media.provider === "YOUTUBE") {
      return this.videoPlayer = new YT.Player('yt-player', {
        height: this.$el.height(),
        width: this.$el.width(),
        videoId: media.media,
        playerVars: {
          'rel': 0,
          'showinfo': 0
        },
        events: {
          onReady: function(e) {
            return e.target.playVideo();
          }
        }
      });
    }
  },
  setFeaturedHeight: function() {
    var bodyWidth, mediaHeight;
    if (this.options.mediaHeight < this.$galleryMedia.height() || this.$galleryMedia.height() === 0) {
      bodyWidth = this.$body.width();
      if (bodyWidth > TABLET_MQ_WIDTH) {
        mediaHeight = this.options.mediaHeight;
      } else {
        mediaHeight = IMAGE_ASPECT_RATIO * this.containerWidth;
      }
    } else {
      mediaHeight = this.$galleryMedia.height();
    }
    this.$gallery.height(mediaHeight);
    if (!(this.$body.hasClass("goods") || this.$body.hasClass("getaways") || this.$body.hasClass("getaways-booking"))) {
      mediaHeight += 3;
    }
    return this.$controls.height(mediaHeight);
  },
  updateGallery: function(newMedia) {
    var $newGalleryMedia, isCurrentVideo, newGalleryMedia, newMediaIndex, onComplete, transitionCSS;
    newMediaIndex = this.collection.indexOf(newMedia);
    if (this.media[newMedia.id]) {
      newGalleryMedia = this.media[newMedia.id];
    } else {
      this.fetchMedia(newMediaIndex);
      newGalleryMedia = this.media[newMedia.id];
    }
    $newGalleryMedia = $(newGalleryMedia);
    if (this.animateViaJS) {
      transitionCSS = {
        opacity: 0
      };
      $newGalleryMedia.css(transitionCSS);
    }
    $newGalleryMedia.appendTo(this.$gallery);
    if (newMediaIndex > 0) {
      this.$leftButton.removeClass("disabled");
    } else {
      this.$leftButton.addClass("disabled");
    }
    if (newMediaIndex < this.collection.size() - 1) {
      this.$rightButton.removeClass("disabled");
    } else {
      this.$rightButton.addClass("disabled");
    }
    this._adjustThumbs(this.collection.indexOf(newMedia));
    if (newMedia.type === "video") {
      this.playVideo(newMedia);
      this.$el.addClass("has-video");
    } else {
      this.$el.removeClass("has-video");
    }
    isCurrentVideo = this.currentFeatured.type === "video";
    onComplete = (function(_this) {
      return function() {
        var ref;
        _this.$gallery.children("[id^='gallery-']:not(#gallery-video-" + _this.currentFeatured.id + ", #gallery-image-" + _this.currentFeatured.id + ")").remove();
        if (isCurrentVideo) {
          if ((ref = _this.videoPlayer) != null) {
            ref.destroy();
          }
          return _this.$gallery.children("#video-container").remove();
        }
      };
    })(this);
    if (this.animateViaJS) {
      transitionCSS = {
        opacity: 1
      };
      $newGalleryMedia.animate(transitionCSS, {
        complete: onComplete
      }, "slow");
    } else {
      setTimeout(onComplete, 600);
    }
    this.$thumbs.find("#gallery-thumb-" + newMedia.id).addClass("selected c-bdr-prim").siblings().removeClass("selected c-bdr-prim");
    this.$galleryMedia = $newGalleryMedia;
    this.currentFeatured = newMedia;
    if (this.options.imageZoom) {
      this._updateImageZoomMessage();
    }
    return this.$body.trigger("carouselUpdate", {
      image: newMedia.baseURL,
      uuid: this.options.uuid
    });
  },
  updateCollection: function(collection) {
    var currentHeight, singleImage;
    this.collection = collection;
    if (!this.collection) {
      return;
    }
    singleImage = this.collection.length === 1;
    if (singleImage) {
      currentHeight = this.$el.height();
    }
    this.undelegateEvents;
    this.collection.uuid = this.options.uuid;
    this.collection.renderFullCarousel = !singleImage;
    this.currentFeatured = this.collection.first();
    this.render();
    if (singleImage) {
      return this.$el.css("min-height", currentHeight);
    }
  },
  _calculateThumbMargins: function(marginalia) {
    if (this.visibleThumbs > 1) {
      return Math.floor(marginalia / (this.visibleThumbs - 1));
    } else {
      return Math.floor(marginalia);
    }
  },
  _calculateThumbsWidth: function() {
    return (this.thumbWidth + this.thumbMargin) * this.$thumbnails.length - this.thumbMargin;
  },
  _calculateZoomRatio: function(width, height) {
    return (width / this.$gallery.width() + height / this.$gallery.height()) / 2;
  },
  _prepareGroups: function() {
    this.thumbGroups = [];
    this.totalGroups = 0;
    this.thumbsPerGroup = 0;
    this.activeGroup = 0;
    this.pnThumbWidth = this.thumbWidth + this.thumbMargin;
    this.pnThumbWrapWidth = this.$thumbnails.length * this.pnThumbWidth;
    if (this.hasOverflow) {
      this._setThumbsPerGroup();
      this._setTotalGroups();
      this._setThumbGroups();
      this._setLastGroupThumbsShort();
      this._setActiveGroup();
      return this._updateThumbsPosition();
    }
  },
  _prepareImageZoom: function() {
    var height, ref, width;
    if (this.options.imageZoom) {
      ref = this.options.imageZoom, width = ref.width, height = ref.height;
    }
    if (!(width && height)) {
      return;
    }
    this.zoomFactor = this._calculateZoomRatio(width, height) - 1;
    this.fetchZoomImage(this.currentFeatured);
    this.$zoomMedia.width(width).height(height);
    this.$controls.addClass("zoom-controls");
    return this._updateImageZoomMessage();
  },
  _scrollThumbsPosition: function() {
    var direction, options;
    direction = this.rtl ? 'right' : 'left';
    options = {};
    options[direction] = -1 * $(this.$thumbnails[this.currentPosition]).position()[direction] + this.$backButton.width();
    if (this.animateViaJS) {
      this.$thumbs.animate(options);
    } else {
      this.$thumbs.css(options);
    }
    if (this.currentPosition === 0) {
      this.$backButton.addClass("disabled");
    } else {
      this.$backButton.removeClass("disabled");
    }
    if (this.currentPosition === this.collection.size() - this.visibleThumbs) {
      return this.$forwardButton.addClass("disabled");
    } else {
      return this.$forwardButton.removeClass("disabled");
    }
  },
  _setActiveGroup: function() {
    var currentIndex, group, i, j, lastRange, len, ref, results;
    currentIndex = this.collection.indexOf(this.currentFeatured);
    lastRange = this.thumbGroups[this.totalGroups - 1];
    ref = this.thumbGroups;
    results = [];
    for (i = j = 0, len = ref.length; j < len; i = ++j) {
      group = ref[i];
      if (currentIndex >= group[0] && currentIndex <= group[1]) {
        if (this.activeGroup !== i) {
          this.activeGroup = i;
          results.push(this._updateThumbsPosition());
        } else {
          results.push(void 0);
        }
      } else {
        results.push(void 0);
      }
    }
    return results;
  },
  _setLastGroupThumbsShort: function() {
    return this.thumbsShort = this.thumbsPerGroup - (this.thumbGroups[this.totalGroups - 1][1] - this.thumbGroups[this.totalGroups - 1][0] + 1);
  },
  _setThumbGroups: function() {
    var end, i, j, ref, results, start;
    results = [];
    for (i = j = 0, ref = this.totalGroups - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
      start = i * this.thumbsPerGroup;
      end = start + this.thumbsPerGroup - 1;
      if (end >= this.$thumbnails.length) {
        end = this.$thumbnails.length - 1;
      }
      results.push(this.thumbGroups[i] = [start, end]);
    }
    return results;
  },
  _setThumbsPerGroup: function() {
    return this.thumbsPerGroup = Math.floor(this.insideContainerWidth / (this.thumbWidth + this.thumbMargin));
  },
  _setTotalGroups: function() {
    return this.totalGroups = Math.ceil(this.thumbsWidth / this.insideContainerWidth);
  },
  _updateThumbsPosition: function() {
    var direction, modifier, options;
    modifier = 0;
    if (this.activeGroup === this.totalGroups - 1) {
      modifier = (this.thumbWidth + this.thumbMargin) * this.thumbsShort;
    }
    direction = this.rtl ? 'right' : 'left';
    options = {};
    options[direction] = (-1 * (((this.insideContainerWidth - this.thumbMargin) * this.activeGroup) - modifier - this.$backButton.width() - this.thumbMargin)) + "px";
    if (this.animateViaJS) {
      return this.$thumbs.animate(options);
    } else {
      return this.$thumbs.css(options);
    }
  },
  _adjustThumbs: function(index) {
    var group, i, j, k, len, ref, ref1, ref2;
    ref = this.thumbGroups;
    for (i = j = 0, len = ref.length; j < len; i = ++j) {
      group = ref[i];
      if (index >= group[0] && index <= group[1] && this.activeGroup !== i) {
        this.activeGroup = i;
        this._updateThumbsPosition();
        for (i = k = ref1 = group[0], ref2 = group[1]; ref1 <= ref2 ? k <= ref2 : k >= ref2; i = ref1 <= ref2 ? ++k : --k) {
          this.fetchMedia(i);
        }
        break;
      }
    }
  },
  _updateImageZoomMessage: function() {
    if (this.currentFeatured.zoom) {
      return this.$imageZoomMessage.css("visibility", "visible");
    } else {
      return this.$imageZoomMessage.css("visibility", "hidden");
    }
  }
});

//# sourceMappingURL=data:application/json;base64,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
